import { ATTENTION_REASONS } from './types'
import type { AttentionReason } from './types'

export { ATTENTION_REASONS }

export const ATTENTION_LABEL: Record<AttentionReason, string> = {
  invitation_not_sent: 'Invitation not sent',
  invite_send_failed: 'Invite send failed',
  invite_send_overdue: 'Invite send overdue',
  invite_expiring: 'Invite expiring',
  invite_expired: 'Invite expired',
  activation_overdue: 'Activation overdue',
  onboarding_overdue: 'Onboarding overdue',
  first_lesson_overdue: 'First lesson overdue',
  placement_review: 'Placement review',
  rubric_review: 'Rubric review',
  suspended_early: 'Suspended early',
  continuity_delayed: 'Progress transfer delayed',
}

/**
 * Operator-facing meaning and next step for each independently-computed
 * attention reason. This is rendered by the Operator FAQ rather than copied
 * into every badge surface; keeping it beside the badge labels makes changes
 * to either side reviewable together.
 */
export const ATTENTION_GUIDANCE: Record<AttentionReason, string> = {
  invitation_not_sent:
    'Send an activation email. The enrollment has started, but the student has not been invited yet.',
  invite_send_failed: 'Check the failure reason and address, then resend.',
  invite_send_overdue:
    'Check the invite scheduler; resend if the student must start now.',
  invite_expiring:
    'Confirm the student can activate before the current link expires.',
  invite_expired:
    'The student can use self-service recovery, or you can resend here.',
  activation_overdue:
    'Contact the student and verify that they received a usable invite.',
  onboarding_overdue: 'Contact the student and help them resume onboarding.',
  first_lesson_overdue:
    'Contact the student and help them start their first lesson.',
  placement_review:
    'The diagnostic was low-confidence, disagreed by two CEFR levels, or needs gentler pacing. This admin does not yet provide a review or resolution action.',
  rubric_review:
    'Review the existing rubric-confidence evidence and clear its owning flag.',
  suspended_early:
    'Confirm the temporary access block is intentional before contract end.',
  continuity_delayed:
    'Open the destination enrollment and check whether the earlier enrollment has ended and its final learning updates have settled. The system keeps retrying automatically.',
}
